import React from "react";

const PHRASES = [
  "Written by you",
  "Delivered in 48h",
  "Yours forever",
  "100% chosen by you",
  "No subscription",
];

export const Marquee = () => {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      className="overflow-hidden border-y border-[rgba(43,38,32,0.1)] bg-cream2 py-8"
      data-testid="marquee"
    >
      <div className="uf-marquee-track">
        {items.map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-serif text-3xl font-medium italic text-ink-soft sm:text-4xl md:text-5xl">
              {p}
            </span>
            <span className="uf-diamond" />
          </span>
        ))}
      </div>
    </div>
  );
};
